// removed by extract-text-webpack-plugin
module.exports = {"sea-buckthron":"#faa634","container":"wechat_container_2oxdp","logoContainer":"wechat_logoContainer_3nc3E","contentContainer":"wechat_contentContainer_1Q6vL","wechatImage":"wechat_wechatImage_34YW0","wechatImage1":"wechat_wechatImage1_2uUub","wechatImage2":"wechat_wechatImage2_1I0XH","content":"wechat_content_p1FTP","sec":"wechat_sec_2lJ07","orange":"wechat_orange_2N37v","orangeV":"wechat_orangeV_9Yc-c","lato-title":"wechat_lato-title_NCq7Y lato-title","lato-subtitle-orange":"wechat_lato-subtitle-orange_1A-Gz lato-subtitle"};


//////////////////
// WEBPACK FOOTER
// ./src/static/solution/wechat/wechat.css
// module id = 377
// module chunks = 4